import { connect } from "react-redux";
import * as Redux from "redux";
import { withRouter } from "react-router-dom";
import {
  setMetricsContainerTab,
  toggleExportModal,
  setMetricSelection
} from "../../actions";
import MetricsSideMenu from "./component";
import { getViewContext, currentMerchantName } from "../../selectors";
import { getUserContext } from "../../../User/selectors";
import { select } from "redux-saga/effects";
import { currentPublications } from "../../../AnalyticsMetric/selectors";
import { AggregatedMetrics, AnalyticsGlobalFilters } from "../../constants";
import { GAContextProps } from "../../../common/google_analytics";

export interface MetricsSideMenuProps {
  analytics_metrics: AggregatedMetrics;
  metrics_container_tab: string;
  merchant_id: number;
  publication_ids: number[];
  start_date: string;
  end_date: string;
  compare_by: string;
  group_by: string;
  view: string;
  permissions: any;
  exportModalVisible: boolean;
  publications: any[];
  globalFilters: AnalyticsGlobalFilters;
}

export interface MetricsSideMenuActions {
  setMetricsContainerTab: (tabname: string) => void;
  setMetricSelection: (metric: string, merchant_id: number) => void;
  toggleExportModal: () => void;
}

const mapStateToProps = (
  state: any,
  props: any
): MetricsSideMenuProps & GAContextProps => {
  return {
    analytics_metrics: state.analytics.analytics_metrics,
    merchant_id: state.analytics.merchant_id,
    publication_ids: state.analytics.publication_ids,
    start_date: state.analytics.start_date,
    end_date: state.analytics.end_date,
    metrics_container_tab: state.analytics.metrics_container_tab,
    compare_by: state.analytics_metric.compare_by,
    group_by: state.analytics_metric.group_by,
    view: state.analytics_metric.view,
    permissions: state.user.permissions,
    merchantName: currentMerchantName(state),
    gaUserContext: getUserContext(state),
    gaViewContext: getViewContext(state),
    exportModalVisible: state.analytics.exportModalVisible,
    publications: currentPublications(state, props),
    globalFilters: state.analytics.globalFilters
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): MetricsSideMenuActions => {
  return {
    ...Redux.bindActionCreators(
      { setMetricsContainerTab, toggleExportModal, setMetricSelection },
      dispatch
    )
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetricsSideMenu)
);



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/MetricsSideMenu/container.ts